import { shareContactsProfileFields } from "../../../types/ProfileField"
import AttachmentsTypes from "../enums/AttachmentsTypes";
import { Modal } from "../../../common/Modal";
import i18n from "../../../service/locale/i18";
import VueI18n from "vue-i18n";

export class ContactsShareHelper {
    i18n: VueI18n | null = null;
    store: any;

    constructor(store: any) {
        this.store = store;
        this.i18n = i18n;
    }

    get profile() {
        return this.store.getters['profile'];
    }

    validateProfile(): boolean {
        return this.getEmptyFields().length === 0 || ((this.profile['email'] || this.profile['phoneNumber']) && this.profile['firstName'] && this.profile['lastName']);
    }

    getAttachments() {
        return [{
            type: AttachmentsTypes.contacts,
            data: {
                firstName: this.profile.firstName,
                lastName: this.profile.lastName,
                phoneNumber: this.profile.phoneNumber,
                position: this.profile.position,
                company: this.profile.company,
                email: this.profile.email
            }
        }]
    }

    getFallbackMessage() {
        let { firstName, lastName, phoneNumber, email, position, company } = this.profile;
        company = (company ? company : '');
        const companyAndPosition = position ? `${position}` + (company ? `, ${company}` : '') : company;

        return `${firstName} ${lastName}
                ${phoneNumber}
                ${email}
                ${companyAndPosition}`;
    }

    async requestToCompleteProfile() {

        const message = this.getModalMessage(this.getEmptyFields());

        const modal = new Modal({
            title: this.i18n?.t('errors.contactsComplete').toString(),
            contentText: message || 'Пожалуйста, заполните <b>номер телефона</b> и <b>email</b>.',
            buttons: [
                {
                    text: this.i18n?.t('common.add data').toString() || '',
                    class: "is-green is-big",
                    returnValue: true,
                }
            ],
            distContainerSelector: '.chat-main'
        });

        const confirm = (await modal.showConfirm());

        return confirm && typeof confirm === "boolean";
    }

    private getModalMessage(emptyFields: string[]): string {
        let message = this.i18n?.t("common.please complete") + ' ';

        return message += `<b>${this.translateString('settings', 'phoneNumber')}</b> ${this.i18n?.t('common.or').toString().toLowerCase()} <b>${this.translateString('settings', 'email')}</b>.`;

        /*if (emptyFields.length === 1) {
            return message += `<b>${this.translateString('settings', emptyFields[0])}</b>.`
        }
        else if (emptyFields.length === 2) {
            const firstWord = this.translateString('settings', emptyFields[0]);
            const secondWord = this.translateString('settings', emptyFields[1]);

            return message += `<b>${firstWord}</b> ${this.i18n?.t('common.and').toString()} <b>${secondWord}</b>.`
        }
        else if (emptyFields.length > 2) {
            emptyFields.forEach((fieldName, index) => {
                if (index < emptyFields.length - 2) {
                    message += `<b>${this.translateString('settings', fieldName)}</b>, `;
                }
                else if (index === emptyFields.length - 2) {
                    message += `<b>${this.translateString('settings', fieldName)}</b> `;
                }
                else if (index === emptyFields.length - 1) {
                    message += `${this.i18n?.t('common.and').toString()} <b>${this.translateString('settings', fieldName)}</b>.`
                }
            });

            return message
        }

        return '';*/
    }

    private getEmptyFields() {
        return shareContactsProfileFields
            .map((item) => item.name)
            .filter((item: any) => this.profile && !this.profile[item]);
    }

    private translateString(prefix: string, title: string) {
        return this.i18n?.t(`${prefix}.${title.toLowerCase()}`).toString().toLowerCase()
    }
}